import types from './types'
import actions from './actions'
import { ALL_ROLE } from '@/services/Const'

export let allRole = {
  name: '所有岗位',
  id: ALL_ROLE
}

export default {
  namespaced: true,
  state: {
    roles: [],
    currentRole: allRole,
  },

  getters: {
    rolesWithAll: state => [allRole].concat(state.roles)
  },

  mutations: {
    [types.REFRESH](state, newRoles) {
      state.roles = newRoles
    },

    [types.DELETE](state, role) {
      state.roles.splice(state.roles.indexOf(role), 1)
    },

    [types.ADD](state, newRole) {
      state.roles.push(newRole)
    },

    [types.MOVE_UP](state, index) {
      let tmp = state.roles[index - 1]
      state.roles[index - 1] = state.roles[index]
      state.roles.splice(index, 1, tmp) // 触发vue的数据响应，否则getters的值不会更新
    },

    [types.UPDATE](state, data) {
      Object.assign(state.currentRole, data)
    },

    [types.SELECT](state, newRole) {
      state.currentRole = newRole
    }
  },
  actions
}
